import { DocumentDocMIcon } from '@alfalab/icons-glyph/DocumentDocMIcon';
import { DocumentImageMIcon } from '@alfalab/icons-glyph/DocumentImageMIcon';
import { DocumentPdfMIcon } from '@alfalab/icons-glyph/DocumentPdfMIcon';
import { DocumentTxtMIcon } from '@alfalab/icons-glyph/DocumentTxtMIcon';
import { DocumentUnknownMIcon } from '@alfalab/icons-glyph/DocumentUnknownMIcon';

function humanFileSize(size) {
    var units = ['Б', 'КБ', 'МБ', 'ГБ'];
    var humanSize = Number(size);
    var factor = 0;
    while (humanSize >= 1024 && factor < units.length - 1) {
        humanSize /= 1024;
        factor += 1;
    }
    humanSize = humanSize.toFixed(2);
    return "".concat(Number(humanSize), " ").concat(units[factor]);
}
var getExtension = function (filename) { return filename.toLowerCase().split('.').pop(); };
function fileIcon(filename) {
    var extension = getExtension(filename);
    switch (extension) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'svg':
        case 'tif':
        case 'tiff':
            return DocumentImageMIcon;
        case 'doc':
        case 'docx':
            return DocumentDocMIcon;
        case 'pdf':
            return DocumentPdfMIcon;
        case 'txt':
            return DocumentTxtMIcon;
        default:
            return DocumentUnknownMIcon;
    }
}

export { fileIcon, getExtension, humanFileSize };
